import React, { useState } from 'react';

const ProjectsSection = () => {
    const [showAllProjects, setShowAllProjects] = useState(false);

    const initialProjects = [
        {
            id: 1,
            title: "Home Improvement & Construction Retailer",
            platform: "Magento 2",
            platformClass: "magento",
            role: "Frontend Engineer",
            problem: "The store had low average order value and a disconnected purchase flow, where installation and related services were not naturally integrated into product purchases.",
            solution: "Implemented a KnockoutJS-based solution to dynamically attach installation and uninstallation services directly to product purchases, creating a bundled purchase experience and improving the checkout flow clarity.",
            impact: ["Increased average order value", "Improved customer satisfaction", "Reduced purchase friction for service-based add-ons"]
        },
        {
            id: 4,
            title: "Tactical Equipment & Outdoor Gear Retailer",
            platform: "BigCommerce",
            platformClass: "bigcommerce",
            role: "Full Stack Engineer",
            problem: "The existing storefront had performance bottlenecks and poor Core Web Vitals, especially on search and listing pages.",
            solution: "Led a full redesign of the theme from scratch, optimizing layout structure, assets, and rendering performance with a strong focus on UX and speed.",
            impact: ["CLS reduced to near zero", "Significant performance improvement on search pages", "Smoother and more consistent user experience"]
        },
        {
            id: 5,
            title: "Secure Storage & Safety Equipment Retailer",
            platform: "WooCommerce",
            platformClass: "woocommerce",
            role: "Full Stack Engineer",
            problem: "The store lacked flexibility for content customization, making it difficult for non-technical users to manage page experiences effectively.",
            solution: "Developed a custom theme using ACF to enable modular content management, improving reusability and giving the client more control over page structure and UX composition.",
            impact: ["Improved content flexibility for marketing team", "Increased design consistency across pages", "Enhanced maintainability and scalability of the theme"]
        }
    ];

    const additionalProjects = [
        {
            id: 2,
            title: "Collectibles & Sports Publishing Retailer",
            platform: "Magento 2",
            platformClass: "magento",
            role: "Frontend Engineer (Team Contributor)",
            problem: "The legacy storefront lacked performance optimization and had usability issues that impacted navigation and product discovery.",
            solution: "Collaborated with a development team to build a new custom theme focused on performance, improved UX structure, and optimized product browsing experience.",
            impact: ["Improved page performance", "Better product discoverability", "Enhanced user experience across catalog navigation"]
        },
        {
            id: 3,
            title: "Firearms Accessories E-commerce Retailer",
            platform: "Magento 2",
            platformClass: "magento",
            role: "Frontend Engineer",
            problem: "The existing storefront design was outdated and did not provide a high-quality, intuitive shopping experience for a complex product catalog.",
            solution: "Developed a new high-fidelity theme based on UX best practices, focusing on clarity, structured product presentation, and improved usability across key shopping flows.",
            impact: ["Improved user experience", "Higher engagement on product pages", "More consistent and modern visual identity"]
        },
    ];

    const allProjects = showAllProjects ? [...initialProjects, ...additionalProjects] : initialProjects;

    return (
        <section id="projects" className="section projects-section">
            <div className="container">
                <h2 className="section-title">Featured Projects</h2>
                <p className="section-subtitle">
                    Real-world case studies demonstrating platform expertise and measurable impact
                </p>

                <div className="projects-grid">
                    {allProjects.map((project) => (
                        <article key={project.id} className="project-card">
                            <div className="project-card__header">
                                <div className="project-card__platform">
                                    <span className={`badge badge--${project.platformClass}`}>
                                        {project.platform}
                                    </span>
                                </div>
                                <h3 className="project-card__title">{project.title}</h3>
                                <p className="project-card__role">{project.role}</p>
                            </div>
                            <div className="project-card__body">
                                <div className="project-card__section">
                                    <p className="project-card__label">Challenge</p>
                                    <p className="project-card__text">{project.problem}</p>
                                </div>
                                <div className="project-card__section">
                                    <p className="project-card__label">Solution</p>
                                    <p className="project-card__text">{project.solution}</p>
                                </div>
                                <div className="project-card__section">
                                    <p className="project-card__label">Impact</p>
                                    <div className="project-card__impact">
                                        {project.impact.map((item, index) => (
                                            <span key={index} className="project-card__impact-tag">
                                                ↑ {item}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>

                {!showAllProjects && (
                    <div className="projects-see-more">
                        <button className="btn btn--secondary btn--large" onClick={() => setShowAllProjects(true)}>
                            See More Projects
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
};

export default ProjectsSection;